import {
  onAttributeSelect,
  onValueSearch
} from '@nile/components/src/Pebbles/AdvancedProjectFilter';
import { onInvoiceViewAttributeSelect } from '@nile/components/src/Pebbles/AdvancedInvoiceFilter';
import { customViewConstraints } from '@nile/components';
import { AccountClient, GET_INVOICE_LIST_VIEW_META } from '@nile/graphql';
import { CLIENT_VIEWS_META } from './constants';

const getCustomViewValues = (module) => {
  const customViewConfig = {
    INVOICE: {
      checkboxLabel: 'task.newView.checkbox.sharedView',
      roleToCheck: {
        add: 'invoiceViews.add',
        edit: 'invoiceViews.edit',
        delete: 'invoiceViews.delete',
        view: 'invoiceViews.view',
        sharedviewId: 'invoiceSharedViews.allow'
      },
      getModuleMeta: GET_INVOICE_LIST_VIEW_META,
      moduleMetaClient: AccountClient,
      moduleMetaInput: 'LIST_VIEW',
      moduleMetaResponseKey: 'getInvoiceListViewMeta',
      onValueSearch: onValueSearch,
      onAttributeSelect: onInvoiceViewAttributeSelect,
      constraints: customViewConstraints,
      showColumns: true
    },
    CLIENT: CLIENT_VIEWS_META
  };

  return customViewConfig[module.toUpperCase()];
};

export { getCustomViewValues };
